export { BankDetail } from '@/components/demographics/bankDetail'
export { BankList } from './list'



// WEBPACK FOOTER //
// ./src/internal-app/pages/banks/index.js